<template>
    <v-dialog
        v-model="showDialog"
        width="600"
    >
        <v-card>
            <v-card-title style="background-color: #009688; color: white;">
                Action Required: Pending {{ pendingType }}s
            </v-card-title>
            <v-card-text style="padding-top: 20px;">
                To approve changes, you must first resolve and approve all pending {{ pendingType.toLowerCase() }} statuses.
            </v-card-text>
            <v-card-actions>
                <v-spacer />
                <v-btn
                    color="teal darken-1"
                    outlined
                    width="180"
                    @click="showDialog = false"
                >
                    Close
                </v-btn>
                <v-btn
                    color="teal darken-1"
                    width="180"
                    style="color: white;"
                    @click="handleShowPending"
                >
                    Show {{ pendingType }}s
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    props: ['show', 'data'],
    computed: {
        showDialog: {
            get() {
                return this.show
            },
            set() {
                this.$emit('closeDialog')
            }
        },
        pendingType() {
            if (this.data) {
                return this.data.pending === 'benefitStatus' ? 'Coverage' : 'Clinic'
            } else {
                return 'test'
            }
        }
    },
    methods: {
        handleShowPending() {
            this.$emit('handleShowPending', this.data)
        }
    }
}
</script>
